import React from 'react';

import {AtomicBlockUtils, EditorState, Modifier, SelectionState} from 'draft-js';
import ImageComponent from './image-component/image-component';

import { ENTITY_TYPE } from "../../api/constants";
import removeBlock from "../block-dnd/modifiers/remove-block";
export const Image = ImageComponent;

export const addImage = (editorState, url, extraData) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
        ENTITY_TYPE.IMAGE,
        'IMMUTABLE',
        _.assign({}, {src: url}, extraData)
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newState1 = AtomicBlockUtils.insertAtomicBlock(
        editorState,
        entityKey,
        ' '
    );

    return EditorState.push(editorState, newState1.getCurrentContent(), 'insert-characters');
}

export default function createImagePlugin(config = {}) {

    const store = {
        getEditorState: undefined,
        setEditorState: undefined,
    };

    let Image = ImageComponent;
    if (config.decorator) Image = config.decorator(Image);

    const onRemove = (blockKey) => {
        const editorState = store.getEditorState();
        const contentState = editorState.getCurrentContent();

        const contentStateAfterRemove = removeBlock(
            contentState,
            blockKey
        );

        // force to new selection
        const newSelection = new SelectionState({
            anchorKey: blockKey,
            anchorOffset: 0,
            focusKey: blockKey,
            focusOffset: 0,
        });
        const newState = EditorState.push(
            editorState,
            contentStateAfterRemove,
            'remove-block'
        );

        store.setEditorState(EditorState.forceSelection(newState, newSelection));
    }

    return {
        initialize: ({ getEditorState, setEditorState }) => {
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },
        blockRendererFn: (block, { getEditorState }) => {
            let res = null;
            if (block.getType() === 'atomic') {
                const contentState = getEditorState().getCurrentContent();
                const entity = block.getEntityAt(0);
                if (!entity) return null;
                const type = contentState.getEntity(entity).getType();
                if (type === ENTITY_TYPE.IMAGE || type === 'image') {
                    res = {
                        component: Image,
                        editable: false,
                        props: {
                            onRemove
                        }
                    };
                }
            }

            return res;
        }
    };
};